import { Button, Card, Col, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import DisponibilidadCardInfo from "./DisponibilidadCardInfo";
import SimpleLoad from "../../../loader/SimpleLoad";
import { forwardRef } from "react";
import DatePicker from "react-datepicker";
import { useHistory } from "react-router";
import useCompanyType from "../../../hook/useCompanyType";

function DisponibilidadSpaceDoctor({t, fechaAgenda, setFechaAgenda, loadSchedule, items, admindoctor}){
    //console.log(items)
    const history = useHistory();
    const companyType = useCompanyType()

    
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <Button variant="light" onClick={onClick} ref={ref}>{value}</Button>
    ));

    const setTimeAppointment = item => {
        //console.log(item)
        if(item.scheduleType.id!=="Blocked"){
            if(admindoctor){
                history.push(`/admin/detalle-cita/${item.appointment.id}`)
            }else{
                if(item.appointment.externalUrl){
                    history.push(`/admin/proveedor/citacliente/${btoa(item.appointment.id)}`)
                }else{
                    history.push(`/admin/proveedor/conferencia/${btoa(item.appointment.id)}`)
                }
            }
        }
    }

    return (
        <Card className="shadow-1">
            {  loadSchedule && <SimpleLoad /> }
            <Card.Body>
                <Row>
                    <Col>   
                        <DatePicker
                            selected={fechaAgenda}
                            onChange={(date) => setFechaAgenda(date)}
                            customInput={<ExampleCustomInput />}
                            dateFormat="dd/MM/yyyy"
                        />
                    </Col>
                </Row>                
                <div className="d-flex flex-column flex-md-row flex-wrap">
                    {companyType !== "colombia" && <div className="pr-2"><span className="indicador-ondemand dot-ondemand mr-2"></span><span className="font-weight-bold-600 font-size-08rem">Ondemand</span></div>}
                    <div className="pr-2"><span className="indicador-programado dot-ondemand mr-2"></span><span className="font-weight-bold-600 font-size-08rem">Programado</span></div>
                    <div className="pr-2"><span className="indicador-cancelado dot-ondemand mr-2"></span><span className="font-weight-bold-600 font-size-08rem">Cancelado</span></div>
                    <div className="pr-2"><span className="indicador-no-disponible dot-ondemand mr-2"></span><span className="font-weight-bold-600 font-size-08rem">No disponible</span></div>
                    <div className="pr-2"><span className="indicador-pendiente dot-ondemand mr-2"></span><span className="font-weight-bold-600 font-size-08rem">Pendiente</span></div>
                    <div className="pr-2"><span className="indicador-reagendada dot-ondemand mr-2"></span><span className="font-weight-bold-600 font-size-08rem">Reagendada</span></div>
                    <div className="pr-2"><span className="indicador-fallida dot-ondemand mr-2"></span><span className="font-weight-bold-600 font-size-08rem">Fallida</span></div>
                    <div className="pr-2"><span className="indicador-pendientepago dot-ondemand mr-2"></span><span className="font-weight-bold-600 font-size-08rem">Pendiente de pago</span></div>
                    <div className="pr-2"><span className="indicador-canceladasinpago dot-ondemand mr-2"></span><span className="font-weight-bold-600 font-size-08rem">Cancelada sin pago</span></div>
                    <div className="pr-2"><span className="indicador-consultorio dot-ondemand mr-2"></span><span className="font-weight-bold-600 font-size-08rem">Consultorio</span></div>
                    <div className="pr-2"><span className="indicador-noatendida dot-ondemand mr-2"></span><span className="font-weight-bold-600 font-size-08rem">No Atendida</span></div>
                </div>

                {
                    items.length === 0 ?
                    <div className="jumbotron mt-3 text-center">
                        <span>Agenda vacía</span>
                    </div> :
                    items.map((item, i)=>(
                        <div key={i} className="mt-3 cursor-pointer">
                            <DisponibilidadCardInfo 
                                item={item} 
                                setTimeAppointment={setTimeAppointment}
                                admindoctor={admindoctor}
                            />
                        </div>
                    ))
                }
                
            </Card.Body>
        </Card>
    )

}

export default withTranslation()(DisponibilidadSpaceDoctor)